import { fg } from '@atlaskit/platform-feature-flags';

import type { LatestPrompt } from '../../experience-application/get-ai-experience-service';

import {
	supportedTranslationLanguagesEnglishAlphabeticalOrder,
	supportedTranslationLanguagesPopularOrder,
} from './types';

export const getSortedSupportedTranslationLanguages = () => {
	if (fg('platform.editor.ai-multi-lang-translations-popular-sort-order')) {
		return supportedTranslationLanguagesPopularOrder;
	}
	return supportedTranslationLanguagesEnglishAlphabeticalOrder;
};

export const isTranslationPrompt = (latestPrompt?: LatestPrompt): boolean =>
	typeof latestPrompt?.presetTitle?.title?.defaultMessage === 'string' &&
	latestPrompt?.presetTitle?.title?.defaultMessage?.includes('Translate to');
